import {
    Box,
    Icon,
    Icons,
    ThemeBorderVariable,
    ThemeColorVariable,
    ThemeIconSizeVariable,
} from "@caspeco/casper-ui-library";

const StatusSuccess = () => {
    const border = `${ThemeBorderVariable.Small} ${ThemeColorVariable.Success}`;
    return (
        <Box
            backgroundColor={ThemeColorVariable.SuccessContainer}
            border={border}
            padding="10px"
            borderRadius="50%"
        >
            <Icon
                icon={Icons.Success}
                size={ThemeIconSizeVariable.XLarge}
                color={ThemeColorVariable.Success}
            />
        </Box>
    );
};

export default StatusSuccess;
